import React, { createContext, useContext, useState, ReactNode } from "react";

interface ModalState {
  id: string;
  isOpen: boolean;
  props?: Record<string, any>;
}

interface ModalContextType {
  modals: ModalState[];
  openModal: (id: string, props?: Record<string, any>) => void;
  closeModal: (id: string) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [modals, setModals] = useState<ModalState[]>([]);

  const openModal = (id: string, props: Record<string, any> = {}) => {
    setModals((prev) => {
      const existingModal = prev.find((modal) => modal.id === id);
      if (existingModal) {
        return prev.map((modal) => (modal.id === id ? { ...modal, isOpen: true, props } : modal));
      }
      return [...prev, { id, isOpen: true, props }];
    });
  };

  const closeModal = (id: string) => {
    setModals((prev) =>
      prev.map((modal) => (modal.id === id ? { ...modal, isOpen: false } : modal))
    );
  };

  return (
    <ModalContext.Provider value={{ modals, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
